import { isFunction } from '../isFunction/isFunction';
import { isNumber } from '../isNumber/isNumber';
const timeouts = new WeakMap();
/**
 * @deprecated Use `debounce` instead
 *
 * Execute callback with delay. When "throttle" is called several times - callback will be executed only once after delay.
 *
 * @param {Function} callback Structure to be cloned.
 * @param {number} ms Structure to be cloned.
 *
 */
/** @deprecated Use `debounced` instead */
export function throttle(callback, ms = 0) {
    if (!isFunction(callback)) {
        return;
    }
    if (!isNumber(ms)) {
        return;
    }
    if (timeouts.has(callback)) {
        clearTimeout(timeouts.get(callback));
    }
    const timer = setTimeout(() => {
        timeouts.delete(callback);
        callback();
    }, ms);
    timeouts.set(callback, timer);
}
